<template>
    <v-wait for="loading date based tasks" class="layout column fill-height">
        <template slot="waiting">
            <vcl-list height='200'></vcl-list>
        </template>
        <date-based-task-card
            v-for="dateBasedTask in dateBasedTasks"
            :key="dateBasedTask.id"
            :value="dateBasedTask"/>

        <div class="subtitle-1" v-if="!dateBasedTasks || dateBasedTasks.length == 0">No date-based tasks due today</div>
    </v-wait>
</template>
<script>
  import {VclList} from 'vue-content-loading';
  import DateBasedTasks from '@/components/DateBasedTasks/DateBasedTasksClient.vue';
  import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';
  import Controls from './Controls.vue';
  import DateBasedTaskCard from '@/components/Calendar/Day/DateBasedTaskCard';
  import {Event} from '../../../plugins/bus';

  export default {
    data() {
      return {
        dateBasedTasks: [],
      };
    },
    mixins: [
      GarageLocations,
      Controls,
      DateBasedTasks,
    ],
    components: {
      DateBasedTaskCard,
      VclList,
    },
    methods: {
      async handleSingleDateBasedTaskCompleted() {
        this.refreshDateBasedTasks();
      },
      async refreshDateBasedTasks() {
        const tasks = await this.getDateBasedTasks();
        this.dateBasedTasks = tasks.filter((t) => !t.isDeleted);
      },
    },
    async mounted() {
      await this.refreshDateBasedTasks();
      this.$bus.$on(Event.DateBasedTaskCompleted, this.handleSingleDateBasedTaskCompleted);
    },
    destroyed() {
      this.$bus.$off(Event.DateBasedTaskCompleted, this.handleSingleDateBasedTaskCompleted);
    },
    watch: {
      async current() {
        await this.refreshDateBasedTasks();
      },
      async userGarage() {
        await this.refreshDateBasedTasks();
      },
    },
  };
</script>
